import React from 'react';
import { DropDown } from './common';
import { LetterProcessingWorkFlow } from 'api';
import { ShowIf, validatable } from 'components/utils';

class DropDownChonQuyTrinhGiaiQuyetDon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      id: this.props.donId,
      selectedValue: this.props.selectedValue
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  componentDidMount() {
    this.getCurrentForm();
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.id != nextProps.donId && nextProps.donId) {
      this.setState({
        id: nextProps.donId,
        selectedValue: nextProps.selectedValue
      });
    }
  }

  getCurrentForm() {
    let params = {};
    if (this.props.loaiDon) {
      params.loaiDon = this.props.loaiDon;
    }
    LetterProcessingWorkFlow.actions.getTrangThaiTTXM.request(null, params).then(res => {
      this.setState({
        data: res.data || []
      });
    });
  }

  render() {
    return (
      <ShowIf condition={this.state.data.length > 1}>
        <DropDown bindValidator={this}
          className={this.props.className}
          channel="formTaoDon"
          label="Quy trình giải quyết"
          selectedValue={this.props.selectedValue}
          require={this.props.require}
          isValid={this.props.isValid}
          options={this.state.data}
          keyName='giaTri'
          valueName='ten'
          onChange={this.onChange.bind(this)}
          placeholder={this.props.placeholder}
          name={this.props.name} />
      </ShowIf>
    )
  }
}

DropDownChonQuyTrinhGiaiQuyetDon.defaultProps = {
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name: ''
}


export default validatable(DropDownChonQuyTrinhGiaiQuyetDon);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonquytrinhgiaiquyetdon.jsx